import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'
import image5 from './images/5.jpg'
import image6 from './images/6.jpg'
import * as styles from './styles.css'

export const TailSection: React.FC = () => {
  return (
    <section className="bg-white py-10 flex flex-col gap-6">
      <h2 className="text-[18px] text-inter font-bold text-black text-center leading-[1.6] px-6">
        バラのある暮らし
        <br />
        まずは1ヶ月お試しください
      </h2>
      <div className={styles.carousel}>
        <div className={styles.images}>
          <img className={styles.image} src={image1} />
          <img className={styles.image} src={image2} />
          <img className={styles.image} src={image3} />
          <img className={styles.image} src={image4} />
          <img className={styles.image} src={image5} />
          <img className={styles.image} src={image6} />
          <img className={styles.image} src={image1} />
          <img className={styles.image} src={image2} />
          <img className={styles.image} src={image3} />
          <img className={styles.image} src={image4} />
          <img className={styles.image} src={image5} />
          <img className={styles.image} src={image6} />
        </div>
      </div>
    </section>
  )
}
